import Api from '@/api/rest/ExchangeBidApi';

export default new Api();
